module.exports = __webpack_public_path__ + "images/emoji/outbox_tray.c12ce495cd2ab70ca6ad.png";